module.exports = __webpack_public_path__ + "static/media/emoji-quite.a9d1ffe2.svg";